/**
 * Tenant e-signature integration settings
 */
export class TenantSettingsESignaturesDto {
  isEnabled?: boolean | null;
  senderSignerEmail?: string | null;
  senderSignerName?: string | null;
}
